import Axios from 'axios';
import { API_URL } from './types';
import { clearPermissionsCache } from '../../utils/permissions';
// Add a request interceptor
const axiosConfig = Axios.create({
  baseURL: API_URL,
  // timeout: 10000,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});
// Interceptors removed from global Axios - only use axiosConfig interceptors

axiosConfig.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  config.headers['AUTH-TOKEN'] = token;
  return config;
});

axiosConfig.interceptors.response.use(undefined, (err) => {
  const error = err.response;

  if (
    error &&
    error.status === 401 &&
    error.config &&
    !error.config.__isRetryRequest
  ) {
    // Auto-logout on 401 for all endpoints (token expired or invalid)
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('email');
    localStorage.removeItem('permissions');
    clearPermissionsCache();
    if (window.location.pathname !== '/sign-in') {
      window.location.href = '/sign-in';
    }
  }

  if (error && error.status === 403) {
    // NO hacer logout — el usuario esta autenticado pero sin permisos
    console.warn('Permiso denegado:', error.data?.message);
  }

  return Promise.reject(err);
});

export const axiosApi = axiosConfig;
